import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { SvgSpacesMediumDs, SvgSpacesMediumDsCertified, SvgSpacesMediumExtract, SvgSpacesMediumExtractCertified } from '../../../../../gen-src/icons';

export interface PublishedDatasourceIconInterface {
  readonly hasExtracts: boolean;
  readonly isCertified: boolean;
}

export function PublishedDatasourceIcon(publishedDatasource: PublishedDatasourceIconInterface) {
  if (publishedDatasource.hasExtracts) {
    if (publishedDatasource.isCertified) {
      return <SvgSpacesMediumExtractCertified />;
    } else {
      return <SvgSpacesMediumExtract />;
    }
  } else {
    if (publishedDatasource.isCertified) {
      return <SvgSpacesMediumDsCertified />;
    } else {
      return <SvgSpacesMediumDs />;
    }
  }
}

export function PublishedDatasourceIconTooltip(publishedDatasource: PublishedDatasourceIconInterface) {
  if (publishedDatasource.hasExtracts) {
    if (publishedDatasource.isCertified) {
      return Messages.DataDetailsCertifiedDatasourceExtract();
    } else {
      return Messages.DataDetailsDatasourceExtract();
    }
  } else {
    if (publishedDatasource.isCertified) {
      return Messages.DataDetailsCertifiedDatasourceLive();
    } else {
      return Messages.DataDetailsDatasourceLive();
    }
  }
}
